export const MIN_DESCRIPTION_LENGTH = 10
export const AUTO_CLOSE_INTERVAL = 1000
export const SUPPORT_HOURS_START = "8:00"
export const SUPPORT_HOURS_END = "19:00"

export const COPY = {
  DESCRIPTION: {
    TITLE: "Let Us Know How We Can Help",
    SUBTITLE:
      "Describe your issue in your own words— we'll share this with our team so that they can help you.",
    LABEL: "Send us a message",
    IMAGE_ALT: "Help Drawer Header",
  },
  CONTACT_PREFERENCES: {
    TITLE: "Best way for us to connect?",
    SUBTITLE: "Let's figure out the best way for our team to get in touch with support.",
    PHONE: {
      TITLE: "Request a phone call",
      DESCRIPTION:
        "For support with questions that might be too much to type or explain in writing.",
      HOURS: "Hours today:",
      BUTTON: "Request call",
      RECOMMENDED: "Recommended",
      CONFIRM_TITLE: "Confirm your phone number",
      ERROR: "Please enter a valid phone number",
      EXISTING_PHONE_NUMBER:
        "The number we have for your account is {phone}. Please let us know if there is a better number for our team to reach you.",
      MISSING_PHONE_NUMBER:
        "Hmm, it doesn't look like we have a phone number associated with your account— please let us know the best number for our team to reach you.",
    },
    EMAIL: {
      TITLE: "Request an email",
      DESCRIPTION: "For complex questions that require attachments or are not urgent.",
      BUTTON: "Send email",
      CONFIRM_TITLE: "Confirm your email address",
      ERROR: "Please enter a valid email address",
      EXISTING_EMAIL:
        "The email we have for your account is {email}. Please let us know if there is a better email for us to reach you.",
      MISSING_EMAIL:
        "Hmm, it doesn't look like we have an email address associated with your account— please let us know the best email for our team to reach you.",
    },
  },
  SUPPORT_REQUEST: {
    TEMPLATE: `User Support Request\n\
====================\n\
\n\
Description: {description}\n\
\n\
Preferred Contact Method: {contactMethod}\n\
\n\
Contact Details: {contactDetails}\n\
\n\
User's Name: {userFullName}\n\
\n\
Estate of: {estateName}\n\
\n\
EstateID: {estateId}\n\
\n\
Estate's Country: {estateCountry}\n\
\n\
Estate's State/Province: {estateState}\n\
{fileInfo}`,
    FILE_INFO: "\n\nUploaded File: {fileName} (ID: {fileId})",
  },
  CLOSE_CONFIRMATION: {
    TITLE: "Are you sure?",
    MESSAGE: "You have unsaved changes. Are you sure you'd like to cancel?",
    CANCEL_CLOSE: "Cancel",
    CONFIRM_CLOSE: "Close",
  },
  BUTTONS: {
    NEXT: "Next",
    BACK: "Back",
    CANCEL: "Cancel",
    SUBMIT: "Submit",
  },
  VALIDATION: {
    DESCRIPTION_REQUIRED: `Please tell us a bit more about your issue (at least ${MIN_DESCRIPTION_LENGTH} characters needed).`,
    FILE_UPLOAD_REQUIRED: "Something went wrong with your file upload, please try again.",
    PHONE_INVALID: "Please provide a valid phone number",
    EMAIL_INVALID: "Please provide a valid email address",
  },
  CONFIRMATION: {
    TITLE: "Request submitted!",
    MESSAGE:
      "We've shared your message internally— someone from our support team will be in touch shortly.",
    SUPPORT_TEAM: "Support Team",
    SUPPORT_INFO:
      "Our team is supported by real humans across the USA and Canada. You can call or text us anytime at +1 (858) 212-0122.",
    DAYS: {
      MONDAY: "Monday",
      TUESDAY: "Tuesday",
      WEDNESDAY: "Wednesday",
      THURSDAY: "Thursday",
      FRIDAY: "Friday",
      SATURDAY: "Saturday",
      SUNDAY: "Sunday",
    },
    APPOINTMENT_ONLY: "* Appointment only",
    VOICEMAIL_MESSAGE:
      "If you call and miss one of our teammates, please leave us a voicemail or text and we'll return the call as soon as possible.",
    FINISH: "Finish",
    AUTO_CLOSE: "Success! Window will automatically close in {seconds} seconds.",
  },
}

export const DAYS: (keyof typeof COPY.CONFIRMATION.DAYS)[] = [
  "MONDAY",
  "TUESDAY",
  "WEDNESDAY",
  "THURSDAY",
  "FRIDAY",
  "SATURDAY",
  "SUNDAY",
]
